export const limitOrdersContract = {
	addresses: {
		1: '0x736d22180993e20cac87E9B2035560c1De455027',
		3: '0xC38776bdB0f02CFa66113F069D1f319f36901736',
		4: '0x3dCf67EdABe1B97B44ed6F34c91B4DA9ef8f4933',
		42: '0xc9c7613845A0c26169288C30eEF2604BeBf3A962',
	},
	abi: [
		{
			anonymous: false,
			inputs: [{ indexed: true, internalType: 'uint256', name: 'orderID', type: 'uint256' }],
			name: 'Cancel',
			type: 'event',
		},
		{
			anonymous: false,
			inputs: [
				{ indexed: true, internalType: 'uint256', name: 'orderID', type: 'uint256' },
				{ indexed: true, internalType: 'address', name: 'submitter', type: 'address' },
				{ indexed: false, internalType: 'address', name: 'executer', type: 'address' },
			],
			name: 'Execute',
			type: 'event',
		},
		{
			anonymous: false,
			inputs: [
				{ indexed: true, internalType: 'uint256', name: 'orderID', type: 'uint256' },
				{ indexed: true, internalType: 'address', name: 'submitter', type: 'address' },
				{ indexed: false, internalType: 'bytes32', name: 'sourceCurrencyKey', type: 'bytes32' },
				{ indexed: false, internalType: 'uint256', name: 'sourceAmount', type: 'uint256' },
				{
					indexed: false,
					internalType: 'bytes32',
					name: 'destinationCurrencyKey',
					type: 'bytes32',
				},
				{
					indexed: false,
					internalType: 'uint256',
					name: 'minDestinationAmount',
					type: 'uint256',
				},
				{ indexed: false, internalType: 'uint256', name: 'executionFee', type: 'uint256' },
				{ indexed: false, internalType: 'uint256', name: 'weiDeposit', type: 'uint256' },
			],
			name: 'Order',
			type: 'event',
		},
		{
			constant: false,
			inputs: [{ internalType: 'uint256', name: 'orderID', type: 'uint256' }],
			name: 'cancelOrder',
			outputs: [],
			payable: false,
			stateMutability: 'nonpayable',
			type: 'function',
		},
		{
			constant: false,
			inputs: [{ internalType: 'uint256', name: 'orderID', type: 'uint256' }],
			name: 'executeOrder',
			outputs: [],
			payable: false,
			stateMutability: 'nonpayable',
			type: 'function',
		},
		{
			constant: false,
			inputs: [{ internalType: 'address', name: 'synthetixAddress', type: 'address' }],
			name: 'initialize',
			outputs: [],
			payable: false,
			stateMutability: 'nonpayable',
			type: 'function',
		},
		{
			constant: true,
			inputs: [],
			name: 'latestID',
			outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
			payable: false,
			stateMutability: 'view',
			type: 'function',
		},
		{
			constant: false,
			inputs: [
				{ internalType: 'bytes32', name: 'sourceCurrencyKey', type: 'bytes32' },
				{ internalType: 'uint256', name: 'sourceAmount', type: 'uint256' },
				{ internalType: 'bytes32', name: 'destinationCurrencyKey', type: 'bytes32' },
				{ internalType: 'uint256', name: 'minDestinationAmount', type: 'uint256' },
				{ internalType: 'uint256', name: 'executionFee', type: 'uint256' },
			],
			name: 'newOrder',
			outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
			payable: true,
			stateMutability: 'payable',
			type: 'function',
		},
		{
			constant: true,
			inputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
			name: 'orders',
			outputs: [
				{ internalType: 'address payable', name: 'submitter', type: 'address' },
				{ internalType: 'bytes32', name: 'sourceCurrencyKey', type: 'bytes32' },
				{ internalType: 'uint256', name: 'sourceAmount', type: 'uint256' },
				{ internalType: 'bytes32', name: 'destinationCurrencyKey', type: 'bytes32' },
				{ internalType: 'uint256', name: 'minDestinationAmount', type: 'uint256' },
				{ internalType: 'uint256', name: 'weiDeposit', type: 'uint256' },
				{ internalType: 'uint256', name: 'executionFee', type: 'uint256' },
			],
			payable: false,
			stateMutability: 'view',
			type: 'function',
		},
	],
};

export default limitOrdersContract;
